<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='1150px')
        template(v-slot:activator='{ on }')
            v-btn(small color='primary' v-on='on')
                v-icon mdi-magnify
        v-card.mx-lg-auto
            v-card-text
                v-img.mt-5(contain :src='imageUrl')
            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                        v-icon mdi-window-close
                        | Close

</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
    },
    computed: {
    },
    components: {
    },
    props: {
        imageUrl: {
            type: String,
            required: true,
        },
    },
    created() {
        return;
    },
});
</script>

<style lang="scss" scoped>
</style>